import {
  IconButtonProps as MuiIconButtonProps,
  default as MuiIconButton,
} from '@mui/material/IconButton';
import { combineCls } from '@/style';

export type IconButtonProps = MuiIconButtonProps;

export const IconButton = ({ children, className, ...rest }: IconButtonProps): JSX.Element => {
  return (
    <MuiIconButton {...rest} className={combineCls(className)}>
      {children}
    </MuiIconButton>
  );
};
